import { TimelineEvent } from "cm-component-library/lib/components/Timeline/Models/TimelineEvent";
import {
  AdvancedSearchAction,
  AdvancedSearchActionType,
  IUpdateAdvancedSearchSettingsPayload,
  ISetFeedbackCreationEventsErroredPayload,
  ISetFeedbackCreationEventsLoadedPayload
} from "../Actions/AdvancedSearchActions";
import { AdvancedSearchSettings } from "../Models/AdvancedSearch/AdvancedSearchSettings";
import { timelineService } from "..";
import { LoadingState } from "../../Common";

export interface AdvancedSearchState {
  isAdvancedSearchDropdownShowing: boolean;
  isTimelineDropdownShowing: boolean;
  settings: AdvancedSearchSettings;
  feedbackCreationEvents: any[];
  feedbackCreationEventsLoadCount: number;
  feedbackCreationEventsLoadState: LoadingState;
  feedbackCreationEventsErrorCode?: number;
  feedbackCreationEventsErrorMessage?: string;
}

const initialAdvancedSearchState: AdvancedSearchState = {
  isAdvancedSearchDropdownShowing: false,
  isTimelineDropdownShowing: false,
  settings: {
    apps: [],
    categories: [],
    states: [],
    startDate: timelineService.getDefaultStartDate(),
    endDate: timelineService.getDefaultEndDate()
  },
  feedbackCreationEvents: [],
  feedbackCreationEventsLoadCount: 0,
  feedbackCreationEventsLoadState: {
    isLoaded: false,
    isLoading: false,
    errored: false
  }
};

const updateObject = (oldObject: any, newValues: any) => ({ ...oldObject, ...newValues });

const advancedSearchReducer = (
  advancedSearchState: AdvancedSearchState = initialAdvancedSearchState,
  action: AdvancedSearchAction
) => {
  switch (action.type) {
    case AdvancedSearchActionType.TOGGLE_ADVANCED_SEARCH_DROPDOWN: {
      // just negate isAdvancedSearchDropdownShowing
      return updateObject(advancedSearchState, {
        isAdvancedSearchDropdownShowing: !advancedSearchState.isAdvancedSearchDropdownShowing
      });
    }
    case AdvancedSearchActionType.TOGGLE_TIMELINE_DROPDOWN: {
      // just negate isTimelineDropdownShowing
      return updateObject(advancedSearchState, {
        isTimelineDropdownShowing: !advancedSearchState.isTimelineDropdownShowing
      });
    }
    case AdvancedSearchActionType.UPDATE_ADVANCED_SEARCH_SETTINGS: {
      const payload = <IUpdateAdvancedSearchSettingsPayload>action.payload;
      return updateObject(advancedSearchState, { settings: payload.settings });
    }
    case AdvancedSearchActionType.SET_FEEDBACK_CREATION_EVENTS_LOADING: {
      return updateObject(advancedSearchState, {
        feedbackCreationEventsLoadState: updateObject(
          advancedSearchState.feedbackCreationEventsLoadState,
          { isLoading: true, isLoaded: false, errored: false }
        )
      });
    }
    case AdvancedSearchActionType.SET_FEEDBACK_CREATION_EVENTS_LOADED: {
      const payload = <ISetFeedbackCreationEventsLoadedPayload>action.payload;
      return updateObject(advancedSearchState, {
        feedbackCreationEventsLoadState: updateObject(
          advancedSearchState.feedbackCreationEventsLoadState,
          { isLoading: false, isLoaded: true, errored: false }
        ),
        feedbackCreationEvents: payload.events,
        feedbackCreationEventsLoadCount: advancedSearchState.feedbackCreationEventsLoadCount + 1
      });
    }
    case AdvancedSearchActionType.SET_FEEDBACK_CREATION_EVENTS_ERRORED: {
      const payload = <ISetFeedbackCreationEventsErroredPayload>action.payload;
      return updateObject(advancedSearchState, {
        feedbackCreationEventsLoadState: updateObject(
          advancedSearchState.feedbackCreationEventsLoadState,
          { isLoading: false, isLoaded: false, errored: true }
        ),
        feedbackCreationEventsErrorCode: payload.errorCode,
        feedbackCreationEventsErrorMessage: payload.errorDescription
      });
    }
    default:
      return advancedSearchState;
  }
};

export default advancedSearchReducer;
